import {BusinessCaseResponseBody} from '@dms/api/sales';
import {Money} from '@dms/api/shared';

import {Nullish} from 'shared/web';

/**
 * The agreed price the counterpart contributes to a trade-in offset.
 *
 * Only a BUYING counterpart offsets the host headline price: we take its buying price (with VAT,
 * falling back to the non-deductible price). SELLING and any other counterpart type contribute
 * nothing, so the offset is left untouched.
 */
export const getTradeInCounterpartPrice = (
  counterpart: BusinessCaseResponseBody | Nullish
): Money | Nullish => {
  const buyingPrice =
    counterpart?.businessCaseType === 'BUYING'
      ? counterpart.offers?.[0]?.purchaseVehicles?.[0]?.buying?.buyingPrice
      : null;

  return buyingPrice?.priceWithVat ?? buyingPrice?.priceNotDeductible ?? null;
};
